<template>
  <div class="works">
    <page-header />
    <audit-temp :audit_status="audit_status" :audit_remark="audit_remark" />
    <page-prompt />
    <section class="main">
      <h2 class="title">区域赛上传作品</h2>
      <div class="msgs">
        <div class="form">
          <el-form label-position="top">
            <el-form-item label="作品名称" :required="true">
              <el-input v-model="works.name" placeholder="请填写作品名称..." :disabled="inputDisabled" />
            </el-form-item>
            <el-form-item label="作品简介" :required="true">
              <el-input v-model="works.intro" type="textarea" :rows="4" maxlength="1000" show-word-limit
                placeholder="请填写作品简介，1000字以内..." :disabled="inputDisabled" />
            </el-form-item>
            <el-form-item v-for="item of fileConfig" :key="item.id" :label="item.title"
              :required="item.is_required === 1">
              <el-input v-if="inputDisabled" type="textarea" :rows="3"
                :value="item.file_url ? `${item.file_url}?${time}` : ''" :disabled="inputDisabled" />
              <file-upload v-else :fileUrl="item.file_url ? `${item.file_url}?${time}` : ''"
                :limitSize="item.limit_size"
                :keyName="`2026works/区域赛/${area_name}/${reg_team_basic.code}/${item.title}`"
                @setFileKey="onSetFileUrl(item.id, $event)" />
              <a v-if="item.temp_url" class="example" :href="DOMAIN.IMG + item.temp_url">
                <i class="el-icon-collection-tag"></i>
                <span>查看示例文件</span>
              </a>
              <div class="prompt">{{ item.remark }}</div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="btn">
        <el-button type="primary" icon="el-icon-back" @click="onPrevPage">返回上一项</el-button>
        <el-button v-if="!inputDisabled" type="success" icon="el-icon-circle-check"
          @click="onSubmit">保存进行下一项</el-button>
        <el-button v-else type="success" icon="el-icon-right" @click="$router.push('/training')">下一项</el-button>
      </div>
    </section>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader'
import PagePrompt from '@/components/PagePrompt'
import FileUpload from '@/components/FileUpload'
import AuditTemp from '@/components/AuditTemp'
import { fetchFileConfig, setWorksCnts } from '@/service/api'
import DOMAIN from '@/config/domain'
import { mapActions } from 'vuex'

export default {
  name: 'PageWorks',
  components: {
    PageHeader,
    PagePrompt,
    FileUpload,
    AuditTemp
  },
  data () {
    return {
      area_name: '',
      reg_team_basic: {},
      audit_status: 3,
      reg_preliminary_expire: false,
      audit_remark: '',
      DOMAIN,
      works: {},
      fileConfig: [],
      time: Math.floor(Date.now() / 1000)
    }
  },
  computed: {
    inputDisabled () {
      return this.audit_status === 2 || this.audit_status === 4 || this.audit_status === 5 || this.reg_preliminary_expire
    }
  },
  methods: {
    ...mapActions('app', [
      'getQnUptoken'
    ]),
    onPrevPage () {
      this.$router.push('/instructor')
    },
    async onSubmit () {
      if (!this.works.name) {
        this.$alert(`请填写作品名称`, '提示', {
          confirmButtonText: '确定'
        })
        return
      }
      if (!this.works.intro) {
        this.$alert(`请填写作品简介`, '提示', {
          confirmButtonText: '确定'
        })
        return
      }
      for (let index = 0; index < this.fileConfig.length; index++) {
        const element = this.fileConfig[index]
        if (element.is_required === 1 && !element.file_url) {
          this.$alert(`请上传${element.title}`, '提示', {
            confirmButtonText: '确定'
          })
          return
        }
      }

      const loading = this.$loading({
        lock: true,
        text: '提交中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.9)'
      })

      try {
        await setWorksCnts({ ...this.works, files: this.fileConfig })
        loading.close()
        this.$router.push('/training')
      } catch (error) {
        loading.close()
        console.log('onSubmit error', error)
      }
    },
    async getFileConfig () {
      try {
        const data = await fetchFileConfig()
        this.reg_preliminary_expire = data.reg_preliminary_expire
        this.area_name = data.area_name
        this.reg_team_basic = data.reg_team_basic
        this.audit_status = data.reg_team_basic.audit_status
        this.audit_remark = data.reg_team_basic.audit_remark
        this.works = data.reg_input_data
        this.fileConfig = data.reg_file_config
      } catch (error) {
        console.log('getFileConfig error', error)
      }
    },
    async onSetFileUrl (id, e) {
      for (const item of this.fileConfig) {
        if (item.id === id) {
          item.file_url = e
          this.time = Math.floor(Date.now() / 1000)
          break
        }
      }
      await setWorksCnts({ ...this.works, files: this.fileConfig })
    }
  },
  async mounted () {
    document.body.style.height = 'auto'
    const loading = this.$loading({
      lock: true,
      text: '加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.9)'
    })
    await this.getQnUptoken()
    await this.getFileConfig()
    loading.close()
  },
  unmounted () {
    document.body.style.height = '100%'
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
